import type { PdfiumApi, PdfiumTypeMap } from "@pdfking/pdfium-wrap"
import { UrlLoad } from "@pdfking/compatibility"
import { CMYK } from "@pdfking/icc"
import { PdfiumExports as E } from "@pdfking/pdfium-wrap"

export type IccTransform = {
  readonly destroy: () => Promise<void>
  readonly handle: PdfiumTypeMap["PDFKING_ICC_TRANSFORM"]
}

export const LoadIccTransform = async (
  api: PdfiumApi,
  iccUrl?: string
): Promise<IccTransform> => {
  const response = await UrlLoad(iccUrl ?? CMYK, "application/octet-stream")
  const iccBytes = new Uint8Array(await response.arrayBuffer())
  const { free: freeIcc, pointer: iccPtr } = api.writeBytes(iccBytes)

  try {
    const handle = await api.call(
      E.PDFKING_ICC_CreateTransform,
      iccPtr,
      iccBytes.length
    )
    return {
      destroy: () => api.call(E.PDFKING_ICC_DestroyTransform, handle),
      handle,
    }
  } finally {
    freeIcc()
  }
}
